import React from 'react';
import { FaPlusCircle } from "react-icons/fa";

const AddButton = ({ activeTable, setOpenModal }) => {
    return (
        <button
            onClick={() => setOpenModal(true)}
            className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-green-500 to-emerald-600 hover:brightness-110 text-white rounded-xl shadow-lg transition duration-300"
        >
            <FaPlusCircle className="text-xl" />
            <span>Add {activeTable}</span>
        </button>
    );
};

export default AddButton;